<template>
  <div class="py-6 px-8">
    <h-header />
    <AdminInvoicesHosts />
  </div>
</template>

<script>
import AdminInvoicesHosts from '../admin/AdminInvoicesHosts'

export default {
  name: 'PartnerInvoices',

  components: {
    AdminInvoicesHosts,
  },
}
</script>
